<div
  id="iris-modal"
  role="dialog"
  [attr.aria-labelledby]="showTitle() && title().trim().length ? 'iris-modal-title' : null"
  [attr.aria-label]="showTitle() && title().trim().length ? null : effectiveAriaLabel()"
  aria-modal="true"
  tabindex="0"
  data-test="iris-modal"
>
  <header class="iris-modal-header" *ngIf="showHeader()">
    <div
      class="title"
      *ngIf="showTitle()"
    >
      <h1
        id="iris-modal-title"
        class="iris-modal-title"
        data-test="connect-modal-title"
      >
        {{ title() }}
      </h1>
    </div>

    <div class="actions-right">
      <ng-content select="[data-iris-modal-header-right]"></ng-content>
      @if (isDismissable()) {
        <iris-icon-button
          (click)="onDismissRequested()"
          class="iris-modal-close"
          icon="close"
          [type]="irisIconButtonTypes.TERTIARY"
          ariaLabel="close"
          data-test="iris-modal-close-icon"
        ></iris-icon-button>
      }
    </div>
  </header>

  <main class="iris-modal-content">
    <ng-content></ng-content>
  </main>
</div>
